export default __webpack_public_path__ + "static/carrier-description-image-8ed306db4812fc562238fc437b7ae260.jpg";